<div class="tile__status" data-testid="tile"
    [ngClass]="{ 'tile__status--active': tile.params.percentage > 0,
        'tile__status--inactive': !(tile.params.percentage > 0) }">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other"
            ngSrc="/assets/img/id_icons/1.svg"
            width="50" height="50" alt="" />
    </div>
    <floating-subtitle class="tile__subtitle"
        [text]="subtitle(961)">
    </floating-subtitle>
    <div class="tile__value" data-testid="tile-value">
        <circle-progress [value]="tile.params.percentage"
                         [showPath]="tile.params.percentage > 0"
                         [angleEnd]="3.6*tile.params.percentage">
        </circle-progress>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
